module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Glass-eea91a98d4ce93131a292073385e3266.png";